// Packages
import { matchPath } from 'react-router-dom';
// Routes
import routes, { TRoute, TSubRoute } from './routes';
import { TPreloadable } from 'helpers/lazyWithPreload';

type TRouteLike = Pick<TRoute | TSubRoute, 'path' | 'exact'> & { component: TPreloadable };

const matches = (pathname: string, { path, exact }: TRouteLike) =>
  !!matchPath(pathname, { path, exact });

// A failed prefetch must stay silent: the page's own `lazy` import reports the real failure.
const warm = ({ component }: TRouteLike) => {
  component.preload?.().catch(() => undefined);
};

/**
 * Starts downloading the chunks of the page a path leads to: the first route that matches, as the
 * router's `Switch` picks it, and its tab. The tab is a second `lazy` chunk, requested only after the
 * page has rendered, so without this the two download one after the other.
 */
const preloadRoute = (pathname: string, routeList: TRoute[] = routes) => {
  const route = routeList.find(candidate => matches(pathname, candidate));

  if (!route) {
    return;
  }

  const tab = route.routes?.find(subRoute => matches(pathname, subRoute));

  warm(route);
  tab && warm(tab);
};

export default preloadRoute;
